<script setup lang="ts">
import { watch } from "vue";
import { formatPrice } from "#/utils/i18next";
import { useAnimationNum } from "../../hooks/useAnimationNum/useAnimationNum";

interface Props {
	price: number | string;
	duration?: number;
	symbol?: string | null;
}
const props = defineProps<Props>();

const { displayNumber: animatedPrice, update: updateCartPrice } = useAnimationNum(Number(props.price) || 0, props.duration || 800);

watch(() => props.price, updateCartPrice, { immediate: true });
</script>

<template><span>{{ formatPrice(animatedPrice, symbol) }}</span></template>
